import { Checkbox, DataSource, HorizontalSpacer, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutControlFileOverrides extends Layout {
    checkboxDisableAutomaticTracking: Checkbox;
    checkboxDisplayYsplitStops: Checkbox;
    checkboxEnforceDepDates: Checkbox;
    checkboxRequireTracking: Checkbox;
    checkboxServiceFailuresReview: Checkbox;
    checkboxUseLocalMile: Checkbox;
    checkboxWaterfallAutoRouteGuides: Checkbox;
    horizontalspacer10: HorizontalSpacer;
    horizontalspacer11: HorizontalSpacer;
    horizontalspacer12: HorizontalSpacer;
    horizontalspacer13: HorizontalSpacer;
    horizontalspacer14: HorizontalSpacer;
    horizontalspacer15: HorizontalSpacer;
    horizontalspacer16: HorizontalSpacer;
    horizontalspacer17: HorizontalSpacer;
    horizontalspacer18: HorizontalSpacer;
    horizontalspacer19: HorizontalSpacer;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    horizontalspacer4: HorizontalSpacer;
    horizontalspacer5: HorizontalSpacer;
    horizontalspacer6: HorizontalSpacer;
    horizontalspacer7: HorizontalSpacer;
    horizontalspacer8: HorizontalSpacer;
    horizontalspacer9: HorizontalSpacer;
    labelT: Label;
    panelMain: Panel;
    panelOverrides: Panel;
    panelTrackingOptions: Panel;
    sourceCustomer: DataSource;
    textboxAutoRate: Textbox;
    textboxBillTemplate: Textbox;
    textboxBillTransferWhen: Textbox;
    textboxDeadheadTarget: Textbox;
    textboxDefRateConfirmTemp: Textbox;
    textboxDisplayEta: Textbox;
    textboxDistanceProfile: Textbox;
    textboxGracePeriod: Textbox;
    textboxMaxPayPercent: Textbox;
    textboxMinsWithinGeofence: Textbox;
    textboxOverrideMaxCityRadius: Textbox;
    textboxQuoteDaysToExpire: Textbox;
    textboxRequiredVendor: Textbox;
    textboxServiceFailures: Textbox;
    textboxShipmentIdentType: Textbox;
    textboxSummaryTemplate: Textbox;
    textboxTargetProfit: Textbox;
    textboxTrackingHoursPrior: Textbox;
    textboxWaterfallLeadTime: Textbox;
    textboxWaterfallNotifyEmail: Textbox;
    textboxWaterfallProcess: Textbox;
}
